'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var environment = require('environment');

var HttpInterceptor = function () {
  _createClass(HttpInterceptor, null, [{
    key: 'factory',

    /* @ngInject */
    value: function factory($q, $state, SessionService) {
      return new HttpInterceptor($q, $state, SessionService);
    }
  }]);

  function HttpInterceptor($q, $state, SessionService) {
    var _this = this;

    _classCallCheck(this, HttpInterceptor);

    Object.assign(this, { $q: $q, $state: $state, SessionService: SessionService });

    this.request = function (config) {
      if (config.url.indexOf('api') !== -1 || config.url.indexOf('token') !== -1 || config.url.indexOf('odata') !== -1) {
        config.url = '' + environment.baseUrl + config.url;
      }

      config.headers = config.headers || {};
      config.timeout = 60000;
      var token = _this.SessionService.authToken;

      if (token) {
        config.headers.Authorization = 'Bearer ' + token;
      }

      return config;
    };

    // TODO: implement 401 redirect when not on login page
    this.responseError = function (rejection) {
      if (rejection.status === 401) {
        _this.SessionService.destroy();
        _this.$state.go('login');
      }

      return _this.$q.reject(rejection);
    };
  }

  return HttpInterceptor;
}();

/* @ngInject */


exports.default = function ($httpProvider) {
  $httpProvider.defaults.headers.delete = { 'Content-Type': 'application/json' };
  $httpProvider.defaults.useXDomain = true;
  $httpProvider.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
  delete $httpProvider.defaults.headers.common['X-Requested-With'];
  $httpProvider.interceptors.push(HttpInterceptor.factory);
};


// WEBPACK FOOTER //
// ./config/http.js